import { KeyValue } from '@/main/models/common';
import {
  SupplierCategoryTypes,
  SupplierCategoryActionTypes
} from './supplierCategoryTypes';

export function getSupplierCategory(): SupplierCategoryActionTypes {
  return {
    type: SupplierCategoryTypes.GET_SUPPLIER_CATEGORY
  };
}

export function saveSupplierCategory(
  data: KeyValue[] | null,
  isError: boolean,
  errorMessages: string[] | null
): SupplierCategoryActionTypes {
  return {
    type: SupplierCategoryTypes.SAVE_SUPPLIER_CATEGORY,
    payload: { data, isError, errorMessages }
  };
}

export function resetReducerSupplierCategory(): SupplierCategoryActionTypes {
  return {
    type: SupplierCategoryTypes.RESET_REDUCER_SUPPLIER_CATEGORY
  };
}
